import classNames from "classnames";
import { memo, type ReactNode } from "react";
import { Card } from "../card";
import { Flex } from "../flex";
import { Text } from "../text";
import * as css from "./settings-rows.module.css";

/** Bordered card of rows with dividers and an optional small heading. */
export const SettingsGroup = memo(function SettingsGroup({
  heading,
  helpText,
  action,
  flushDividers,
  children,
}: {
  heading?: string;
  helpText?: string;
  action?: ReactNode;
  flushDividers?: boolean;
  children: ReactNode;
}) {
  return (
    <Flex className={css.group} dir="column" gap="md" w="full">
      {heading && (
        <Flex
          align="center"
          gap="xl"
          justify="space-between"
          px="2xl"
          title={helpText}
        >
          <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
            {heading}
          </Text>
          {action && <Flex shrink={0}>{action}</Flex>}
        </Flex>
      )}
      <Card
        borderColor="secondary"
        borderRadius="md"
        className={classNames(css.rowList, flushDividers && css.rowListFlush)}
        gap="none"
        noPadding
        overflow="hidden"
        w="full"
      >
        {children}
      </Card>
    </Flex>
  );
});
